import { omit } from 'remeda';
import z from 'zod';

import { PlateParagraph } from './Paragraph';
import { ELEMENT_TYPES } from '../constants';

export const CaptionTitle = z.object({
    ...omit(PlateParagraph.shape, ['id']),
    type: z.literal(ELEMENT_TYPES.CAPTION_TITLE),
});

export type CaptionTitleElement = z.infer<typeof CaptionTitle>;
